import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharedFeedbackDetailData } from "../../modules/user/shared_feedback/typeSharedFeedbacks";
import { FeedbackDetailAPICallProps } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const sharedFeedbackDetail = createAsyncThunk(
  "feedback/shared/detail",
  async (params: FeedbackDetailAPICallProps, storeActions) => {
    const url = `api/v1/user/feedbacks/shared/detail?feedbackId=${params.feedbackId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedFeedbackDetailSlice = createSlice({
  name: "sharedFeedbackDetails",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as SharedFeedbackDetailData | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sharedFeedbackDetail.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(sharedFeedbackDetail.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(sharedFeedbackDetail.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedFeedbackDetailSlice.actions;

export default sharedFeedbackDetailSlice;
